export default "__VITE_ASSET__Bfdq74B0__"